import { render, staticRenderFns } from "./UserSelectorDialog.vue?vue&type=template&id=0f53c058&scoped=true"
import script from "./UserSelectorDialog.vue?vue&type=script&lang=js"
export * from "./UserSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./UserSelectorDialog.vue?vue&type=style&index=0&id=0f53c058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53c058",
  null
  
)

export default component.exports